namespace Matrix.Data {
    export class DataReportParametersColumns {
        static columnsKey = 'Data.DataReportParameters';
    }
}
